import {
    WidgetActionType,
    WidgetTypeActionPayload,
} from 'widgets/store/actions';
import { Action } from 'store/store';
import { WidgetType } from 'widgets/WidgetType';

export interface SetGridColumnWidthPayload<TColumnId extends string>
    extends WidgetTypeActionPayload {
    columnId: TColumnId;
    width: number;
}

export interface SetGridColumnWidthAction<TColumnId extends string>
    extends Action<
        WidgetActionType.WIDGET_SET_GRID_COLUMN_WIDTH,
        SetGridColumnWidthPayload<TColumnId>
    > {
    payload?: SetGridColumnWidthPayload<TColumnId>;
}

export function createWidgetSetColumnWidthAction<TColumnId extends string>(
    widgetType: WidgetType,
    widgetKey: string
) {
    if (!widgetType || !widgetKey) {
        throw new Error('No widget type or widget key received');
    }
    return (
        columnId: TColumnId,
        width: number
    ): SetGridColumnWidthAction<TColumnId> => ({
        type: WidgetActionType.WIDGET_SET_GRID_COLUMN_WIDTH,
        payload: { widgetType, widgetKey, columnId, width },
    });
}
